'use strict';

var _countryMap = require('./country-map');

var _countryMap2 = _interopRequireDefault(_countryMap);

var _currencyMap = require('./currency-map');

var _currencyMap2 = _interopRequireDefault(_currencyMap);

var _lodash = require('lodash.findkey');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // mapping of escaped currency symbol (eg '&euro;') to actual currency character


var currencySymbolMap = {
  'pound': '\xA3',
  'euro': "\u20AC",
  'yen': '\xA5'
};

function getCountry(countryName) {
  return _countryMap2.default[countryName];
}

function getCurrency(currencyAbbr) {
  return _currencyMap2.default[currencyAbbr];
}

function getCurrencyAbbreviation(countryName) {
  var country = getCountry(countryName);

  if (country) {
    return country.currency;
  }

  return undefined;
}

function formatCurrency(value, currencyAbbr) {
  var currency = getCurrency(currencyAbbr);

  if (currency) {
    return currency.symbolFormat.replace(/&(\w+);/, function (match, p1) {
      return currencySymbolMap[p1] || p1;
    }).replace('{#}', value);
  }

  return value + ' ' + currencyAbbr;
} // Returns a list of currency objects.


function getCurrencyList() {
  var currencyArray = Object.keys(_currencyMap2.default).map(function (currencyAbbr) {
    return {
      abbr: currencyAbbr,
      name: _currencyMap2.default[currencyAbbr].name,
      symbolFormat: _currencyMap2.default[currencyAbbr].symbolFormat
    };
  });
  return currencyArray;
}

function getCurrencyAbbreviationFromName(currencyName) {
  var abbr = (0, _lodash2.default)(_currencyMap2.default, function (c) {
    return c.name === currencyName;
  });
  return abbr;
}

function getCountryByAbbreviation(countryAbbr) {
  var country = (0, _lodash2.default)(_countryMap2.default, {
    'abbreviation': countryAbbr
  });
  return country;
}

module.exports.getCountry = getCountry;
module.exports.getCurrency = getCurrency;
module.exports.getCurrencyAbbreviation = getCurrencyAbbreviation;
module.exports.formatCurrency = formatCurrency;
module.exports.getCurrencyList = getCurrencyList;
module.exports.getCurrencyAbbreviationFromName = getCurrencyAbbreviationFromName;
module.exports.getCountryByAbbreviation = getCountryByAbbreviation;